<template>
  <px-lateral-dialog content-class="rounded-card" v-model="dialog" width="800">
    <template v-slot:activator="{ on }">
      <v-btn color="error"
             class="mr-3 rounded-tag-small normal-btn-text elevation-0"
             v-on="on">
        Cancelar
      </v-btn>
    </template>
    <template v-slot:title>
      Cancelar compra
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="required rounded-tag-small"
            label="Motivo do cancelamento"
            counter="1500"
            rows="4"
            v-model="motivoRecusa"
            :error="$v.motivoRecusa.$error"
            @blur="$v.motivoRecusa.$touch()"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn text class="normal-btn-text" @click="close">
        Fechar
      </v-btn>
      <v-btn color="primary" class="normal-btn-text rounded-tag-small"
             :loading="loading" @click="onClickCancelar">
        Enviar cancelamento
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import CompraService from '@/modules/compra/compra-service';

export default {
  props: {
    compra: Object,
  },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      motivoRecusa: null,
    };
  },
  methods: {
    onClickCancelar() {
      if (this.validateForm()) {
        return;
      }
      this.cancelar();
    },
    cancelar() {
      this.loading = true;
      CompraService.cancelar(this.compra.id, this.buildCompra())
        .then(() => {
          this.$emit('movimentar');
          this.$toast('Compra cancelada com sucesso', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    },
    buildCompra() {
      return {
        id: this.compra.id,
        motivoRecusa: this.motivoRecusa,
      };
    },
  },
  validations: {
    motivoRecusa: {
      required,
    },
  },
};
</script>
